import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <Inquiries />
      <Footer />
    </div>;
}